import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert, Box, Button, Typography } from '@mui/material';
import PublicNavbar from '../../components/public/PublicNavbar';
import { focusRing } from '../../components/public/landingStyles';
import alertsService from '../../services/alerts';

const UnsubscribePage: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [message, setMessage] = React.useState('');
  const [error, setError] = React.useState('');
  const [busy, setBusy] = React.useState(false);

  const unsubscribe = async () => {
    setBusy(true);
    setError('');
    setMessage('');
    try {
      const result = await alertsService.unsubscribe(token);
      setMessage(result.message || 'Deal change emails are off for this account.');
    } catch (err: unknown) {
      const apiMessage = (err as { response?: { data?: { error?: { message?: string } } } })?.response?.data
        ?.error?.message;
      setError(apiMessage || 'The unsubscribe link could not be confirmed. Try again from the email, or turn alerts off in Profile.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <PublicNavbar />
      <Box id="main" component="main" tabIndex={-1} sx={{ px: { xs: 2, sm: 3 }, py: { xs: 4, md: 6 }, maxWidth: 720, mx: 'auto' }}>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 800, mb: 1, fontSize: { xs: '2rem', md: '2.4rem' } }}>
          Deal change emails
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          This turns off emails about saved deals whose comps or assumptions change. It does not delete
          the deal, and it is not a price-drop list.
        </Typography>
        {!token && (
          <Alert severity="info">This page needs the unsubscribe link from a deal-change email.</Alert>
        )}
        {token && !message && (
          <Button variant="contained" onClick={unsubscribe} disabled={busy} sx={{ minHeight: 44, ...focusRing }}>
            {busy ? 'Turning off…' : 'Turn off deal change emails'}
          </Button>
        )}
        {message && <Alert severity="success" sx={{ mt: 2 }}>{message}</Alert>}
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      </Box>
    </Box>
  );
};

export default UnsubscribePage;
